var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3618_15460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4422 3.12109H14.1748V11.1111H37.5572V7.23451C37.5572 4.96616 35.7112 3.12109 33.4422 3.12109Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5352 12.3403H0V4.92636C0 2.20972 2.21068 0 4.92828 0H12.1336C12.8497 0 13.5396 0.150925 14.1664 0.434509C15.0418 0.828964 15.7939 1.47913 16.3213 2.3286L22.5352 12.3403Z",
    fill: "#60D744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14.0004V37.8817C42 40.153 40.1511 42.0003 37.8789 42.0003H4.12111C1.84891 42.0003 0 40.153 0 37.8817V9.88086H37.8789C40.1511 9.88086 42 11.7288 42 14.0004Z",
    fill: "#60D744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14.0004V37.8817C42 40.153 40.1511 42.0003 37.8789 42.0003H21V9.88086H37.8789C40.1511 9.88086 42 11.7288 42 14.0004Z",
    fill: "#60D744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.048 25.9395C32.048 32.032 27.0919 36.9884 21.0001 36.9884C14.9083 36.9884 9.95215 32.032 9.95215 25.9395C9.95215 19.8481 14.9083 14.8916 21.0001 14.8916C27.0919 14.8916 32.048 19.8481 32.048 25.9395Z",
    fill: "#E7ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0479 25.9395C32.0479 32.032 27.0918 36.9884 21 36.9884V14.8916C27.0918 14.8916 32.0479 19.8481 32.0479 25.9395Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5612 26.0758C24.3308 26.2709 24.0485 26.3661 23.7688 26.3661C23.4185 26.3661 23.0705 26.2177 22.827 25.9287L22.2307 25.2218V29.8499C22.2307 30.5292 21.6795 31.0803 21.0002 31.0803C20.3209 31.0803 19.7698 30.5292 19.7698 29.8499V25.2218L19.1734 25.9287C18.7344 26.4481 17.9587 26.5145 17.4392 26.0758C16.9201 25.6378 16.8535 24.8617 17.2915 24.3422L19.7271 21.4548C20.0447 21.0793 20.508 20.8633 21.0002 20.8633C21.4924 20.8633 21.9558 21.0793 22.2733 21.4548L24.7089 24.3422C25.147 24.8617 25.0803 25.6378 24.5612 26.0758Z",
    fill: "#60D744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.561 26.0758C24.3306 26.2709 24.0483 26.3661 23.7686 26.3661C23.4183 26.3661 23.0703 26.2177 22.8268 25.9287L22.2305 25.2218V29.8499C22.2305 30.5292 21.6793 31.0803 21 31.0803V20.8633C21.4922 20.8633 21.9555 21.0793 22.2731 21.4548L24.7087 24.3422C25.1467 24.8617 25.0801 25.6378 24.561 26.0758Z",
    fill: "#60D744"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3618_15460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5b6fbfc0e2d2ee578fc88fd70e6bb190.svg";
export { ForwardRef as ReactComponent };